var exports = {
  "m": "CustomerStories__xWvvf5",
};

module.exports = exports;
